import * as React from 'react';

const UnlockIcon = ({fillColor = '#2D2756'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 12 16"
    fill="none">
    <path
      fill={fillColor}
      d="M1.506 16.25c-.415 0-.77-.147-1.065-.441A1.452 1.452 0 0 1 0 14.742v-7.82c0-.415.147-.77.441-1.065.295-.294.65-.441 1.065-.441H8.75V3.75a2.41 2.41 0 0 0-.73-1.77 2.41 2.41 0 0 0-1.77-.73c-.605 0-1.133.19-1.583.571-.451.381-.737.854-.858 1.42a.648.648 0 0 1-.251.368.714.714 0 0 1-.433.141.609.609 0 0 1-.445-.177.439.439 0 0 1-.134-.418A3.691 3.691 0 0 1 3.808.907 3.602 3.602 0 0 1 6.25 0c1.04 0 1.926.365 2.655 1.095C9.635 1.825 10 2.709 10 3.75v1.667h.993c.416 0 .771.147 1.066.441.294.295.441.65.441 1.065v7.82c0 .416-.147.771-.441 1.066-.295.294-.65.441-1.066.441H1.506Zm0-1.25h9.487a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.185v-7.82a.25.25 0 0 0-.072-.184.25.25 0 0 0-.185-.072H1.506a.25.25 0 0 0-.184.072.25.25 0 0 0-.072.184v7.82a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072Zm4.744-2.708c.405 0 .75-.142 1.033-.426.284-.284.425-.628.425-1.033 0-.405-.141-.749-.425-1.033a1.407 1.407 0 0 0-1.033-.425c-.405 0-.75.142-1.033.425a1.407 1.407 0 0 0-.425 1.033c0 .405.141.75.425 1.033.284.284.628.426 1.033.426Z"
    />
  </svg>
);

export default UnlockIcon;
